import { LOCAL_STORAGE } from '../../../constants'

export const registerRequestInterceptor = async (request) => {
  request.use((config) => {
    const token = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
    const CountryCode = 'id'
    let Authorization = ''
    if (token) Authorization = `Bearer ${token}`
    return {
      ...config,
      headers: {
        countrycode: CountryCode,
        'x-product-line': 'lcl',
        Authorization,
        ...config.headers,
      },
    }
  })
}

export default registerRequestInterceptor
